<style scoped lang="scss">
p {
  font-size: 14px;
  line-height: 30px;
  color: #333;
}

i {
  top: 20px;
  right: 20px;
  font-size: 60px;
}

.btns {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 20px;
  background-color: white;

  z-index: 200;

  ul {
    justify-content: space-between;
  }

  .width49 {
    width: 48%;
  }
}

/deep/ .el-card__header {
  flex: 0 0 auto;
}

/deep/ .el-card__body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding-bottom: 130px;
}
</style>

<template>
  <el-card class="flex0 ml15 info flex column relative" :style="heightStyle">
    <div slot="header">
      <span>安排信息</span>
    </div>
    <i class="absolute iconfont" :class="statusClass"></i>
    <div>
      <p>申请转入医院：{{ info.hopeHosName }}</p>
      <p v-if="info.transferBusinessDeptName">申请转入科室：{{ info.transferBusinessDeptName }}</p>
      <p>转出医院：{{ info.initHosName }}</p>
      <p v-if="info.initBusinessDeptName">申请转出科室：{{ info.initBusinessDeptName }}</p>
      <p>申请时间：{{ info.hopeTime | timeFilter("YYYY/MM/DD HH:mm") }}</p>
      <p>安排时间：{{ info.referralTime | timeFilter("YYYY/MM/DD HH:mm") }}</p>
      <p>出车方式：{{ getDispatchingCarDesc(info) }}</p>
      <p>意向运送要求：{{ info.hopeTransportRequirement }}</p>
      <p>意向转诊要求：{{ info.referralRequirement }}</p>
      <p>备注：{{ info.remark }}</p>
      <el-alert
          title="请尽快完善具体出车安排"
          type="warning"
          :closable="false"
          show-icon
          v-if="info.referralStatus === 'NEED_ARRANGE'"
      >
      </el-alert>
      <p class="mt15">
        出车方：{{
          info.transportHosName
        }}<font class="color_red" v-if="!info.transportHosName">暂未安排</font>
      </p>
      <p>
        车牌号：{{
          info.licensePlateNo
        }}<font class="color_red" v-if="!info.licensePlateNo">暂未安排</font>
      </p>
      <p class="flex oh">
        <label class="flex0">司机：</label>
        <span class="flex1">
          <font
              class="color_red"
              v-if="
              !info.emergencyStaffingList || !info.emergencyStaffingList.length
            "
          >暂未安排</font
          >
          <template
              v-for="(item, idx) in info.emergencyStaffingList"
              v-if="item.emergencyPersonnelType === 'AID_DRIVER'"
          >
            {{ item.emergencyPersonnelName }}
            {{ item.emergencyPersonnelMobile }}</template
          >
        </span>
      </p>
      <p class="flex oh">
        <label class="flex0">急救医生：</label>
        <span class="flex1">
          <font
              class="color_red"
              v-if="!info.emergencyStaffingList || !info.emergencyStaffingList.length">暂未安排</font>
          <template
              v-for="(item, idx) in info.emergencyStaffingList">
           <b v-if="item.emergencyPersonnelType === 'DOC'" :key="idx">{{ item.emergencyPersonnelName }}
            {{ item.emergencyPersonnelMobile }}</b></template>
        </span>
      </p>
      <p class="flex oh">
        <label class="flex0">急救护士：</label>
        <span class="flex1">
          <font
              class="color_red"
              v-if="
              !info.emergencyStaffingList || !info.emergencyStaffingList.length
            "
          >暂未安排</font
          >
          <template
              v-for="item in info.emergencyStaffingList"
              v-if="item.emergencyPersonnelType === 'NURSE'"
          >
            {{ item.emergencyPersonnelName }}
            {{ item.emergencyPersonnelMobile }} <br/></template>
        </span>
      </p>
      <p class="flex oh">
        <label class="flex0">主管医生：</label>
        <span class="flex1">
          <font
              class="color_red"
              v-if="!info.directorDoc">暂未安排</font>
          <b>{{ info.directorDoc }} {{ info.directorDocMobile }}</b>
        </span>
      </p>
      <p class="mt15">
        申请时间：{{ info.createTime | timeFilter("YYYY-MM-DD HH:mm:ss") }}
      </p>
      <p>处理时间：{{ info.modifyTime | timeFilter("YYYY-MM-DD HH:mm:ss") }}</p>
      <p>救护车定位：</p>
      <car-map :info="info" @big="()=>$refs.bigMap.show()"></car-map>
    </div>

    <!--    急救管理员-->
    <template v-if="isAID_ADM">
      <!--待安排-发起-->
      <div
          class="btns"
          v-if="info.referralStatus === 'NEED_ARRANGE' && aspectUser === 'init'"
      >
        <ul>
          <!--<li class="flex0 width49">
            <el-button
                          :loading="appShowLoading"
                          @click="cancel"
                          style="width: 100%"
                          type="primary"
                      >取消申请
                      </el-button>
                    </li>-->
          <li class="">
            <el-dropdown trigger="click" style="width: 100%" @command="intoVideo">
              <el-button style="width: 100%" type="success">
                视频呼叫
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item,index) in intoVideoDropDownItem" :key="index"
                                  :command="item.id">{{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <!--待安排-接收-->
      <div
          class="btns"
          v-if="info.referralStatus === 'NEED_ARRANGE' && aspectUser === 'accept'"
      >
        <ul class="flex">
          <li class="flex1">
            <el-dropdown trigger="click" style="width: 100%" @command="intoVideo">
              <el-button style="width: 100%" type="success">
                视频呼叫
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item,index) in intoVideoDropDownItem" :key="index"
                                  :command="item.id">{{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
        <ul class="flex mt10">
          <li class="flex0 width49">
            <el-button
                @click="cancel"
                style="width: 100%"
                type="danger"
            >拒绝转诊
            </el-button>
          </li>
          <li class="flex0 width49">
            <el-button style="width: 100%" type="primary" @click="arrange">安排转诊
            </el-button>
          </li>
        </ul>
      </div>
      <div
          class="btns"
          v-if="info.referralStatus === 'NEED_RECEIVE_AND_SEND' &&isInit">
        <ul class="flex mb10" v-if="showWsccapBtn&&!isWsccxx">
          <li class="flex1">
            <el-button style="width: 100%" type="warning" @click="perfect">
              完善出车安排
            </el-button>
          </li>
        </ul>
        <ul class="flex">
          <li class="flex0 width49" v-if="isInit">
            <el-button style="width: 100%" type="primary" @click="changeStatus">
              患者已送出
            </el-button>
          </li>
          <li :class="[isInit?'flex0 width49':'flex0']">
            <el-dropdown trigger="click" style="width: 100%" @command="intoVideo">
              <el-button style="width: 100%" type="success">
                视频呼叫
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item,index) in intoVideoDropDownItem" :key="index"
                                  :command="item.id">{{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <div
          class="btns"
          v-if="info.referralStatus === 'NEED_RECEIVE_AND_SEND' &&isAccept"
      >
        <ul class="flex">
          <li class="flex0 width49">
            <el-button style="width: 100%" type="primary" @click="perfect">修改转诊
            </el-button>
          </li>
          <li class="flex0 width49">
            <el-dropdown trigger="click" style="width: 100%" @command="intoVideo">
              <el-button style="width: 100%" type="success">
                视频呼叫
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item,index) in intoVideoDropDownItem" :key="index"
                                  :command="item.id">{{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <div class="btns" v-if="info.referralStatus === 'IN_TRANSIT'">
        <ul class="flex">
          <li class="flex0 width49" v-if="isAccept">
            <el-button style="width: 100%" type="primary" @click="finishStatus">确认送达
            </el-button>
          </li>
          <li class="flex0 width49">
            <el-dropdown trigger="click" style="width: 100%" @command="intoVideo">
              <el-button style="width: 100%" type="success">
                视频呼叫
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item v-for="(item,index) in intoVideoDropDownItem" :key="index"
                                  :command="item.id">{{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
      <div
          class="btns"
          v-if="info.referralStatus === 'CANCEL' && aspectUser === 'init'"
      >
        <ul class="flex">
          <li class="flex1">
            <el-button style="width: 100%" type="primary" @click="repeat">重新申请
            </el-button>
          </li>
        </ul>
      </div>
      <div class="btns" v-if="isInit&&referralStatus==='NEED_EXAMINE'">
        <!--<ul>
                  <li>
                    <el-button style="width: 100%" type="primary" @click="cancel">
                      取消申请
                    </el-button>
                  </li>
                </ul>-->
      </div>
      <div class="btns" v-if="isInit&&referralStatus==='NEED_APPLICATION'">
        <ul>
          <li>
            <el-button :loading="requestLoading" style="width: 100%" type="primary" @click="reapply">
              申请转诊
            </el-button>
          </li>
        </ul>
      </div>
    </template>

    <!--    审核管理员-->
    <div class="btns" v-if="isAID_E_ADM&&isAccept&&referralStatus==='NEED_EXAMINE'">
      <ul>
        <li>
          <el-button style="width: 100%" type="primary" @click="selectDept">
            选择临床业务科室
          </el-button>
        </li>
        <li class="mt15">
          <el-button
              @click="refuse"
              style="width: 100%"
              type="danger"
          >拒绝转诊
          </el-button>
        </li>
      </ul>
    </div>

    <perfect-car-dialog ref="perfectCar" :aspect-user="aspectUser"></perfect-car-dialog>
    <arrange-dialog ref="arrange" :aspect-user="aspectUser"></arrange-dialog>
    <add-dialog ref="add"></add-dialog>
    <select-dept-dialog ref="selectDept" :aspect-user="aspectUser"/>
    <big-map-dialog ref="bigMap" :info="info"></big-map-dialog>
  </el-card>
</template>

<script>
import {timeFilter} from "@/common/lib/filters";
import {staffService} from "../service/staff";
import PerfectCarDialog from "./perfect-cheliang-dialog";
import ArrangeDialog from "./arrange-dialog";
import AddDialog from "./add-dialog";
import {hushiMixin} from "@/common/lib/mixins/hushi";
import {isEmpty} from "@/common/lib/utils";
import {INTOVIDEOPUSHTYPE, STAFF_PROCEDURE_STATUS} from "../config";
import CarMap from "./map";
import {STAFF_PROCESS_ORDER_SUCCESS} from "../events";
import BigMapDialog from "./big-map-dialog";
import {DispatchingCarMixin} from "../mixins";
import SelectDeptDialog from "@/modules/staff/components/select-dept-dialog";

export default {
  name: "jijiu-detail-info",
  components: {SelectDeptDialog, BigMapDialog, CarMap, AddDialog, ArrangeDialog, PerfectCarDialog},
  filters: {timeFilter},
  mixins: [hushiMixin, DispatchingCarMixin],
  props: {
    info: {
      type: Object,
      default: () => Object.create(null)
    },
    aspectUser: String
  },

  computed: {
    isWsccxx() { // 出车信息是否已经完善
      const {transportHosName, emergencyAmbulanceId, emergencyStaffingList = []} = this.info;
      const hasCcf = transportHosName;// 有出车方
      const hasCph = emergencyAmbulanceId; // 车牌号
      const hasSj = emergencyStaffingList.filter(r => r.emergencyPersonnelType === 'AID_DRIVER').length; // 司机
      const hasJjys = emergencyStaffingList.filter(r => r.emergencyPersonnelType === 'DOC').length;// 急救医生
      const hasJjhs = emergencyStaffingList.filter(r => r.emergencyPersonnelType === 'NURSE').length;// 急救护士
      return hasCcf && hasCph && hasSj && hasJjys;
    },
    referralStatus() {
      return this.info.referralStatus;
    },
    isInit() {
      return this.aspectUser === 'init';
    },
    isAccept() {
      return this.aspectUser === 'accept';
    },
    heightStyle() {
      return {
        height: `${window.innerHeight - 60 - 30}px`
      }
    },
    hopeDispatchingCarType() {
      return this.info.dispatchingCarType || this.info.hopeDispatchingCarType || "";
    },

    showWsccapBtn() {// 是否显示完善出车安排按钮
      return this.hopeDispatchingCarType === 'SUB_HOSPITAL_AMBULANCE'
    },

    intoVideoDropDownItem() {
      const {aspectUser} = this;
      const {referralStatus, hopeHosName, initHosName} = this.info;
      let list = [...INTOVIDEOPUSHTYPE].filter(r => r.enabled.includes(aspectUser));
      if (referralStatus === "NEED_ARRANGE") {
        list = list.filter(r => !['ambulance', 'tripartite'].includes(r.id))
      }
      list = list.map(r => {
        let name = r.name.replace("上级医院", hopeHosName);
        name = name.replace("下级医院", initHosName);
        return {...r, name}
      })
      return list;
    },
    statusClass() {
      const {referralStatus} = this.info;
      if (referralStatus === "CANCEL") return "icon-jujue color_red";
      if (
          [
            "NEED_RECEIVE_AND_SEND",
            "NEED_COMMENT",
            "IN_TRANSIT",
            "ALREADY_COMMENT"
          ].includes(referralStatus)
      )
        return "icon-tongyi color_main";
    }
  },
  methods: {
    selectDept() {
      this.$refs.selectDept.show(this.info);
    },

    cancel() {
      this.$confirm("是否取消该订单?").then(async () => {
        if (await staffService.cancelOrder(this.info.id)) {
          bus.$emit(STAFF_PROCESS_ORDER_SUCCESS.id, 0);
        }
      });
    },

    refuse() {
      this.$prompt("请输入拒绝理由", {
        inputValidator(value) {
          if (value) return true;
          return '拒绝理由不能为空'
        }
      }).then(async ({value}) => {
        const code = await staffService.orderExamine({
          orderId: this.info.id,
          auditStatus: false,
          disagreeReason: value
        })
        if (code === '0') {
          this.$message.success('已拒绝');
        }
      });
    },
    perfect() {
      this.$refs.perfectCar.show(this.info);
    },
    arrange() {
      this.$refs.arrange.show(this.info);
    },
    modify() {
      this.$refs.arrange.show({...this.info, action: "perfect"});
    },

    reapply() {
      let info = {...this.info};
      this.$refs.add.show(info, 'addConsultOrder');
      //this.repeat()
    },

    repeat() {
      let info = {...this.info};
      [
        "id",
        "hopeHosId",
        "hopeTime",
        "hopeDispatchingCarType",
        "referralRequirement",
        "hopeTransportRequirement"
      ].forEach(r => {
        delete info[r];
      });
      this.$refs.add.show(info);
    },
    async intoVideo(command) {
      const data = await staffService.intoVideo(this.info.id, command);
      !isEmpty(data) &&
      this.callV2({
        ...data,
        userId: this.loginInfo.id,
        userName: this.loginInfo.staffName
      })
      /*this.call({
        ...data,
        UID: data.uid
      });*/
    },
    changeStatus() {
      // if (!this.isWsccxx) return this.$message.error('请完善出车信息或联系接收方医院完善出车信息！');
      this.$confirm(`是否确认交接病人?`).then(async () => {
        if (
            await staffService.changeOrderState({
              procedureStatus: STAFF_PROCEDURE_STATUS[4].id,
              orderId: this.info.id
            })
        ) {
          location.reload();
        }
      });
    },
    finishStatus() {
      this.$confirm(`是否确认送达?`).then(async () => {
        if (
            await staffService.changeOrderState({
              procedureStatus: STAFF_PROCEDURE_STATUS[5].id,
              orderId: this.info.id
            })
        ) {
          location.reload();
        }
      });
    }
  }
};
</script>
